import { Key, ReactNode } from 'react';
import { IAccount } from './account.type';

export interface IBaseList<T = string> {
  label: string;
  value?: T;
  id?: string;
  options?: IBaseList<T>[];
  disabled?: boolean;
}

export interface IBasePagingRes<T> {
  data: T[];
  total: number;
}

export interface IBaseProps {
  children: any;
}

export interface IBaseQuery {
  page?: number;
  // limit?: number;
  take: number;
  cursor?: string;
  search?: string;
  init?: boolean;
}

export enum HttpStatusCode {
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  ERROR_SERVER = 500,
  NOT_FOUND = 404,
  BAD_REQUEST = 400,
  SUCCESS = 200,
}

export interface IBaseState<T> {
  loading: boolean;
  total: number;
  data: T[];
  refresh: boolean;
  page: number;
  detail?: T;
  // selected: T[];
  // filterDrawler: boolean;
  // countFilter: number;
}

export interface IBaseConfirmModalParams {
  title?: string;
  content?: string;
  contentHtml?: string;
  onOk: () => Promise<boolean> | boolean;
}

export interface IPropsIcon {
  size?: number;
  color?: string;
}

export interface IBreadcrumb {
  title: string;
  path: string;
}

export interface IBaseResponse<T> {
  [x: string]: any;
  data: T;
  message?: string;
  errors?: IErrorResponse[];
}

export interface IErrorResponse {
  message: string;
  extensions: { code: EErorCode };
}

export enum EErorCode {
  FORBIDDEN = 'FORBIDDEN',
  TOKEN_EXPIRED = 'TOKEN_EXPIRED',
  INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
  ECONNABORTED = 'ECONNABORTED',
}

export interface IBaseEntity {
  id: string;
  created_at: string;
  updated_at: string;
  deleted_at?: string;
  created_by?: string;
  updated_by?: string;
  deleted_by?: string;
  owner?: string;
  user_created?: IAccount;
  user_updated?: IAccount;
  user_deleted?: IAccount;
}

export interface IFlattenOptionData<T> {
  data: T;
  group?: boolean;
  groupOption?: boolean;
  key: Key;
  label?: ReactNode;
  value?: any;
}

export interface IPinAction {
  label: string;
  eventHandler: () => void;
}

export interface IMapPin {
  center: {
    latitude: number;
    longitude: number;
  };
  options: {
    title?: string;
    icon?: string;
    color?: string;
    subTitle?: string;
    description?: string;
  };
  infobox?: {
    title: string;
    description?: string;
    showPointer?: boolean;
    showCloseButton?: boolean;
    actions?: IPinAction[];
  };
}

export type TypeStatusColor = 'danger' | 'warning' | 'success' | 'secondary' | undefined;
